import { render } from "./FooterSection.vue?vue&type=template&id=0da3876c"
import script from "./FooterSection.vue?vue&type=script&lang=js"
export * from "./FooterSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/mugonat-caaz-omnibox/htdocs/caaz-omnibox.mugonat.com/releases/21/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__